const ViewWorkOffModal = () => {
  return <div>휴무확인 모달</div>;
};

export default ViewWorkOffModal;
